export default __webpack_public_path__ + "static/media/right_character.908d4650.png";